import ExecAPI from 'appRoot/api/api';

export function GetUserData()
{
	return ExecAPI("UserData/GetUserData");
}
export function SetUserData(userData)
{
	return ExecAPI("UserData/SetUserData", { userData });
}
export function AddUser(userData)
{
	return ExecAPI("UserData/AddUser", { userData });
}
export function RemoveUser(userId)
{
	return ExecAPI("UserData/RemoveUser", { userId });
}
/**
 * (Admin) Lists a user's MCP API tokens (never their values).
 * @param {Number} userId User ID.
 * @returns {Promise} Promise that delivers { tokens }.
 */
export function GetUserApiTokens(userId)
{
	return ExecAPI("UserData/GetUserApiTokens", { userId });
}
/**
 * (Admin) Revokes any user's MCP API token.
 * @param {Number} id Token ID.
 * @returns {Promise} Promise that delivers the owner's remaining tokens: { tokens }.
 */
export function RevokeUserApiToken(id)
{
	return ExecAPI("UserData/RevokeUserApiToken", { id });
}